<div class="simulator-iframe-layout" *ngIf="isReady">
  <app-sales-simulator-kredicash-embedded></app-sales-simulator-kredicash-embedded>
</div>

<div *ngIf="!isReady" style="display: flex; justify-content: center; align-items: center; height: 100vh;">
  <p>Cargando...</p>
</div>